import * as BABYLON from 'babylonjs';

const AnimationDisplay = {
  startTime: null,
  targetCameraSettings: {},
  speed: 0.05,
  initialMeshState: {
    rotation: new BABYLON.Vector3(-0.2, 0, 0.2),
    position: new BABYLON.Vector3(0, 0, 0),
  },
  
  CAMERA_SETTINGS: {
    1: {
      alpha: 2,
      beta: 2,
      radius: 7,
    },
    2: {
      alpha: Math.PI / 40,
      beta: Math.PI / 2.25,
      radius: 20,
    }
  },

  setTargetCameraSettings(position) {
    this.targetCameraSettings = this.CAMERA_SETTINGS[position];
  },

  interpolateCamera(camera) {
    if (this.targetCameraSettings) {
      camera.alpha += (this.targetCameraSettings.alpha - camera.alpha) * this.speed;
      camera.beta += (this.targetCameraSettings.beta - camera.beta) * this.speed;
      camera.radius += (this.targetCameraSettings.radius - camera.radius) * this.speed;
    }
  },

  firstAnimation(mesh, camera) {
    this.setTargetCameraSettings(2);
    this.interpolateCamera(camera);

    mesh.rotation.copyFrom(this.initialMeshState.rotation);
    mesh.position.copyFrom(this.initialMeshState.position);

    const currentTime = performance.now();
    const elapsedTime = currentTime - this.startTime;
    const rotationSpeed = 2 * Math.PI / 20000;
    const rotation = (elapsedTime * rotationSpeed) % (2 * Math.PI);
    mesh.rotation.y = rotation;
  },

  secondAnimation(mesh, camera) {
    this.setTargetCameraSettings(1);
    this.interpolateCamera(camera);

    mesh.rotation.x = mesh.rotation.x % (2 * Math.PI);

    const speed = 0.05;
    const targetPosition = new BABYLON.Vector3(0, 2, -5);
    const targetRotation = new BABYLON.Vector3(BABYLON.Tools.ToRadians(0), BABYLON.Tools.ToRadians(208), BABYLON.Tools.ToRadians(25));

    mesh.position.addInPlace(targetPosition.subtract(mesh.position).scale(speed));
    mesh.rotation.addInPlace(targetRotation.subtract(mesh.rotation).scale(speed));
  },

  applyAnimation(mesh, activeSection, camera) {
    if (activeSection === 1) {
      this.secondAnimation(mesh, camera);
    } else {
      this.firstAnimation(mesh, camera);
    }
  },

  animateAll(meshes, activeSection, camera) {
    meshes.forEach((mesh) => {
      this.applyAnimation(mesh, activeSection, camera);
    });
  },

  // Réinitialiser l'état des meshes et de la caméra
  resetMeshesAndCamera(meshes, camera) {
    meshes.forEach(mesh => {
      mesh.rotation.copyFrom(this.initialMeshState.rotation);
      mesh.position.copyFrom(this.initialMeshState.position);
    });

    camera.alpha = this.CAMERA_SETTINGS[1].alpha;
    camera.beta = this.CAMERA_SETTINGS[1].beta;
    camera.radius = this.CAMERA_SETTINGS[1].radius;
  },

  cleanup(meshes, camera) {
    this.startTime = null;
    this.targetCameraSettings = {};

    // Réinitialiser les meshes et la caméra
    if (meshes && camera) {
      this.resetMeshesAndCamera(meshes, camera);
    }
  }
};

export default AnimationDisplay;